// 올인원 비즈니스 플랫폼 주요기능 카드
export const FUNCTION_CARDS = Object.freeze([
	{
		icoNum: 'ico22',
		title: '전자결재',
		description:
			'기업 내 모든 업무 문서부터 자금 집행 문서까지<br /> ERP 연동 전자결재로 체계적인 업무 처리와 업무 효율 향상',
		type: 'e-approval',
		new: true
	},
	{
		icoNum: 'ico0',
		title: '경영보고서',
		description:
			'빠르고 정확한 의사결정을 위한 스마트한 비지니스 통찰, <br /> 매출·이익·외상·인사·재고는 물론 손익지표 요약까지',
		type: 'bareport',
		new: true
	},
	{
		icoNum: 'ico1',
		title: '기초정보',
		description: '데이터관리를 위한 외부기관연동 설정에서 고정자산, 전기자료 등 <br /> 기초가 되는 정보 입력',
		type: 'basis',
		new: true
	},
	{
		icoNum: 'ico2',
		title: `거래수집`,
		description: '계좌입출금, 카드사용내역, 국세청 매입/매출 내역 <br /> 자동수집 및 자동전표처리',
		type: 'transaction',
		new: true
	},
	{
		icoNum: 'ico3',
		title: '회계관리',
		description:
			'경영데이터 자동분개부터 말만해AI를 통한 챗봇형 전표 <br/>자동생성까지, 간편한 회계처리 및 경영상황을 한눈에 파악 ',
		type: 'accountancy',
		aiTag: true,
		new: true
	},
	{
		icoNum: 'ico4',
		title: '금융관리',
		description: '자체 스크래핑 기술을 통한 <br /> 실시간 계좌조회에서 이체까지 통합 금융 관리',
		type: 'finance'
	},
	{
		icoNum: 'ico5',
		title: '인사급여',
		description: '사원관리, 4대보험신고, 급여관리에서 퇴직금 관리, <br /> 원천세 신고까지 통합 제공',
		type: 'hr'
	},
	{
		icoNum: 'ico6',
		title: '재고관리',
		description: '입/출고 및 재고조정을 통한 수불부 관리부터 재고평가, 이익현황, <br /> 재고잔량 분석 제공',
		type: 'stock'
	},
	{
		icoNum: 'ico7',
		title: '영업관리',
		description: '견적서, 수주서 입력, 발송 및 출고처리 연동으로 <br /> 체계적인 견적/수주 관리 가능',
		type: 'sales'
	},
	{
		icoNum: 'ico8',
		title: 'B2B 수발주',
		description:
			'가장 간편한 기업 간 거래를 위한 B2B 수발주 서비스 <br /> 견적, 발주, 결제까지 모든 절차를 손쉽게 처리',
		type: 'b2b'
	},
	{
		icoNum: 'ico11',
		title: '장부/결산',
		description: '전문적인 회계지식 없이도 <br /> 결산전표 자동 분개처리 및 장부생성, 결산 가능',
		type: 'ledger'
	},
	{
		icoNum: 'ico9',
		title: '세금신고',
		description: '클릭 한번으로 부가세신고서 작성 및 파일생성, <br /> 원천세신고를 위한 서류 자동생성',
		type: 'tax'
	},
	{
		icoNum: 'ico10',
		title: '제증명발급',
		description: '기업 운영에 필요한 증빙문서발급 및 <br /> 전자문서 발행기능 제공',
		type: 'dms'
	}
]);

// 올인원 비즈니스 플랫폼 편의기능 카드
export const CONVENIENCE_CARDS = Object.freeze([
	{
		icoNum: 'ico23',
		title: '말만해 AI',
		description: '업계 최초 · 챗봇형 전표 자동 생성. 채팅 입력만으로<br /> 계정과목·거래처 자동 완성, 전표 작성 끝',
		type: 'pharosAI',
		new: true,
		beta: true
	},
	{
		icoNum: 'ico24',
		title: '영수증 업로드',
		description: '영수증 이미지 업로드로 거래 정보 자동 인식<br>수집 불가 증빙의 전표 처리 업무 간소화',
		type: 'receiptocr',
		new: true,
		beta: true
	},
	{
		icoNum: 'ico13',
		title: '대시보드',
		description: '시각 데이터로 손익과 매출현황, 계좌/카드내역 등 <br /> 기업의 경영상황 파악 및 인사이트 제공',
		type: 'dashboard'
	},
	{
		icoNum: 'ico14',
		title: '신용정보',
		description: '업계 최초 자사의 신용등급 관리와 함께 <br /> 거래 업체의 신용정보 확인 및 거래위험 파악',
		type: 'credit'
	},
	{
		icoNum: 'ico15',
		title: '부가세신고',
		description: '스텔라에 등록한 회계전표 내역을 자동으로<br />부가세 신고서로 변환하여 간편하게 작성',
		type: 'vat'
	},
	{
		icoNum: 'ico16',
		title: '세금계산서',
		description: '매입매출전표 등록 및 수정 시 <br /> 거래명세서, 세금계산서 버튼 클릭만으로 동시 발행 가능',
		type: 'taxInvoice'
	},
	{
		icoNum: 'ico21',
		title: '모바일 재고관리',
		description:
			'ERP 연동 재고정보를 모바일에서 실시간 확인하고 <br />입고·출고·재고조정·창고이동·제품등록을 간편하게 처리해요.',
		type: 'mim',
		new: true
	},
	{
		icoNum: 'ico17',
		title: '기간비용 & 기간수익',
		description: '기간에 걸쳐있는 비용과 수익을 <br /> 정확하게 관리',
		type: 'costprofit'
	},
	{
		icoNum: 'ico18',
		title: '반제관리',
		description: '매출채권(AR)∙매입채무(AP) 반제관리 및 <br /> 채권연령관리',
		type: 'offsetmanagement'
	},
	{
		icoNum: 'ico25',
		title: '보고서',
		description: '수기 작성이 필요 없는 <br />경영보고서·금융보고서·급여보고서·월간결산보고서 자동 생성',
		type: 'report',
		new: true
	},
	{
		icoNum: 'ico19',
		title: '세무대리인 소통함',
		description: '이제 세무대리인과 <br /> 더 쉽고 빠르게 소통하세요.',
		type: 'community'
	}
]);

// Stella의 차별화 포인트 카드
export const DIFFERENT_FUNCTION_CARDS = Object.freeze([
	{
		title: '최소화된 사용자 개입 / <br /> 최대화된 정보 활용',
		description: 'Stella는 데이터 수집과 입력이라는 반복적/소모적인 <br /> 업무에서 사용자를 자유롭게 합니다.',
		subTitles: ['자동화된 데이터 수집', 'AI 기반 데이터 입력'],
		subDescs: [
			[
				'고성능 데이터 스크래핑 기술을 통해 은행 거래 내역, 세금계산서, <br /> 신용카드 정보 등 다양한 외부 데이터를 자동으로 확보',
				'번거로운 수작업 없이 <br /> 정확하고 신뢰할 수 있는 정보획득 가능'
			],
			[
				'거래 증빙만으로도 필요한 데이터를 추천받아 빠르고 <br /> 편리하게 입력 가능',
				'핵심 경영 정보를 자동으로 수집·분석해 즉각적인 인사이트 제공',
				'사용자는 데이터 입력이라는 단순 업무에서 해방되어 <br /> 보다 가치있는 업무에 집중'
			]
		]
	},
	{
		title: '무한 확장성의 <br />모듈형 ERP',
		description: '삼일의 Digital Solution뿐만 아니라 다양한 <br /> 솔루션과의 연동이 가능한 Hub 형 ERP를 지향합니다.',
		subTitles: ['삼일 디지털 솔루션 연계', 'ERP Eco-System 구현'],
		subDescs: [
			[
				'업무 자동화, 데이터 분석, 재무·회계·주주 관리 등 <br /> 삼일회계법인의 다양한 디지털 솔루션과 밀접하게 연동',
				'세무신고 자동화, 공시재무제표 자동화, 경영데이터 분석 자동화 등 다양한 자동화 솔루션 제공'
			],
			[
				'Stella는 모듈형으로 설계되어 필요에 따라 <br /> Third party 솔루션을 자유롭게 추가/연동 가능',
				'기업 운영 전반을 아우르는 Hub 형 ERP 역할을 수행'
			]
		]
	},
	{
		title: '데이터 허브로 <br /> 분석 가치 극대화',
		description:
			'Stella는 주어진 보고서나 시각화자료에 그치지 않고 <br /> 데이터 허브를 사용자에게 제공하여 사용자가 직접 데이터를 <br /> 분석하고 활용할 수 있도록 지원합니다.',
		subTitles: ['Connected Data Hub', 'AI 기반 인사이트'],
		subDescs: [
			[
				'Stella는 운영 DB와 분리된 분석 목적의 데이터 허브 제공',
				'데이터 허브의 데이터를 분석할 수 있는 ‘스마트 워크스테이션’제공',
				'스마트 워크스테이션에서 내부 보고서 작성부터 경영 분석까지 <br /> 유연하고 빠르게 처리 가능'
			],
			['AI를 활용하여 기업의 데이터나 문서를 비즈니스 인사이트로 전환', '의사결정을 강화하고 기업 경쟁력을 극대화 가능']
		]
	}
]);
